import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/directory-profiles')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/professionals' });
  },
});
